/**
 * Single source of truth for the companion name in non-React modules.
 * Reads from VITE_COMPANION_NAME at build time. Falls back to "Maya", the
 * default persona (#3066).
 *
 * React components should prefer `useCompanionName()` so per-family overrides apply.
 * This module is for static modules (navigation, registry, helpers) that have no
 * access to React context.
 */
export const COMPANION_NAME: string = import.meta.env.VITE_COMPANION_NAME || 'Maya';

/**
 * The staff copilot's name: what TRFers and admins talk to, in chat and on
 * voice. Mirrors `backend/src/config/copilot.js`. Never Maya: families
 * default to Maya, and staff screens show both names side by side (#3066,
 * Victor 2026-10-20). One fleet-wide name; staff have no persona picker.
 */
export const COPILOT_NAME = 'William';

/**
 * The PRODUCT brand. Deliberately independent of `COMPANION_NAME` — mirrors
 * `backend/src/config/companion.js`. Composing the product name out of the
 * persona showed a "Maya" family the "TRF Maya Platform" in legal copy.
 */
export const BRAND_NAME: string = import.meta.env.VITE_BRAND_NAME || 'TRF Imagine';

export const PLATFORM_NAME: string = `${BRAND_NAME} Platform`;
